'use strict';

module.exports = {
    NOTIFICATION_REQ_SINGLE: 'notificationReq.single',
    NOTIFICATION_REQ_AGGREGATED: 'notificationReq.aggregated'
};